import { render, staticRenderFns } from "./VRadio.vue?vue&type=template&id=70770add&"
import script from "./VRadio.vue?vue&type=script&lang=js&"
export * from "./VRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports